const base = '';

async function req(path, opts = {}) {
  const res = await fetch(base + path, {
    credentials: 'include',
    headers: { 'content-type': 'application/json', ...(opts.headers || {}) },
    ...opts,
  });
  if (!res.ok) {
    let detail = '';
    try { detail = (await res.json()).error || ''; } catch {}
    const err = new Error(detail || `${res.status} ${res.statusText}`);
    err.status = res.status;
    throw err;
  }
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : res.text();
}

export const api = {
  auth: (role, password) =>
    req('/api/auth', { method: 'POST', body: JSON.stringify({ role, password }) }),

  logout: () => req('/api/auth/logout', { method: 'POST', body: '{}' }),

  montage: () => req('/api/montage'),
};
